import { Component, Inject } from '@angular/core';

import { menuActions } from '@src/store/reducers/menuReducer';
import { SessionService } from '@src/services';
import { Store } from '@src/store';
import { reportType } from '@src/constants';

@Component({
    selector: 'breadcrumbs',
    template: require('./breadcrumbs.component.html'),
    styles: [require('./breadcrumbs.component.scss')]
})
export class BreadcrumbsComponent {
    private envNameLocalStorageKey = 'env_name';
    private name: string = null;
    public locationMap = [];

    constructor(
        @Inject('$state') private $state: any,
        @Inject('$rootScope') $rootScope: any,
        @Inject('$stateParams') private $stateParams: any,
        private sessionService: SessionService,
        private store: Store) {
        $rootScope.$on('$stateChangeSuccess', () => {
            this.loadMap();
        });
        this.loadMap();
    }

    public navigate(event: any, location: any) {
        event.preventDefault();
        this.$state.go(location.sref, location.params);
    }

    public backClicked() {
        if (history.length > 0) {
            history.back();
        }
    }

    public canGoBack() {
        return history.length > 0;
    }

    private addEnvNameToBreadCrumbs(sref: any) {
        const envName = this.sessionService.get(this.envNameLocalStorageKey + this.$state.params.envID);
        if (!envName || envName === 'undefined') {
            this.sessionService.set(this.envNameLocalStorageKey + this.$state.params.envID, this.$state.params.envName);
        }
        this.locationMap.push({ sref, name: envName || this.$state.params.envName });
    }

    public isInProjects() {
        return this.locationMap.find(item => item.name === 'Projects' && this.locationMap.length > 1);
    }

    private loadMap() {
        this.locationMap = [];
        this.name = this.sessionService.get(`project_${this.$state.params.id}`);
        let envNameSref = '';
        switch (this.$state.current.name) {
        case 'app.authorized.settings.cmsManagement':
            this.locationMap.push({ name: 'CMS Manager', sref: 'app.authorized.settings.cmsManagement' });
            break;
        case 'app.authorized.settings.vaultManagement':
            this.locationMap.push({ name: 'Vaults', sref: 'app.authorized.settings.vaultManagement' });
            break;
        case 'app.authorized.settings.chatbotManagement':
            this.locationMap.push({ name: 'Chatbots', sref: 'app.authorized.settings.chatbotManagement' });
            break;
        case 'app.authorized.settings.agent':
            this.locationMap.push({ name: 'Agent', sref: 'app.authorized.settings.agent' });
            break;
        case 'app.authorized.settings.admin':
            this.locationMap.push({ name: 'Admin', sref: 'app.authorized.settings.admin' });
            break;
        case 'app.authorized.logViewer':
            this.locationMap.push({ name: 'Logs', sref: 'app.authorized.logViewer' });
            break;
        case 'app.authorized.reports.details':
            this.locationMap.push({ name: 'Audit', sref: 'app.authorized.reports.details' });
            break;
        case 'app.authorized.reports.dp':
            this.locationMap.push({ name: 'Release Package Delivery', sref: 'app.authorized.reports.dp' });
            break;
        case 'app.authorized.reports.summrize':
            this.locationMap.push({ name: 'Audit Summary', sref: 'app.authorized.reports.summrize' });
            break;
        // case 'app.authorized.reports.package.details':
        //     this.locationMap.push({ name: 'reports package details', sref: 'app.authorized.reports.package.details' });
        //     break;    
        case 'app.authorized.projects':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            break;
        case 'app.authorized.environments':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.name = (!this.name) ? this.$stateParams.name : this.name;
            this.locationMap.push({
                    name: this.name,
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            this.locationMap.push({
                    name: 'Environments',
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            break;
        case 'app.authorized.packages':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                    name: this.name,
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            this.locationMap.push({ name: 'Packages', sref: 'app.authorized.packages' });
            break;
        case 'app.authorized.configurationsView':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                    name: this.name,
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            this.locationMap.push({ name: 'Configurations', sref: 'app.authorized.configurationsView' });
            break;
        case 'app.authorized.taskManager':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                    name: this.name,
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            this.locationMap.push({ name: 'Task Manager', sref: 'app.authorized.taskManager' });
            break;
        case 'app.authorized.cmsTaskManager':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                    name: this.name,
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            this.locationMap.push({ name: 'CMS Task Manager', sref: 'app.authorized.cmsTaskManager' });
            break;
        case 'app.authorized.environment.settings':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                    name: this.name,
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            this.locationMap.push({
                    name: 'Environments',
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            envNameSref = 'app.authorized.environment.settings';
            this.addEnvNameToBreadCrumbs(envNameSref);
            this.locationMap.push({ name: 'Environment Settings', sref: 'app.authorized.environment.settings' });
            break;
        case 'app.authorized.environment.automation':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                    name: this.name,
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            this.locationMap.push({
                    name: 'Environments',
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            envNameSref = 'app.authorized.environment.automation';
            this.addEnvNameToBreadCrumbs(envNameSref);
            this.locationMap.push({ name: 'Environment Automation', sref: 'app.authorized.environment.automation' });
            break;
        case 'app.authorized.environment.schemas':
        case 'app.authorized.environment.databases':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                    name: this.name,
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            this.locationMap.push({
                    name: 'Environments',
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            envNameSref = this.$state.current.name;
            this.addEnvNameToBreadCrumbs(envNameSref);
            const dbTypeName = (this.$state.current.name === 'app.authorized.environment.databases' ? 'Database' : 'Schema');
            this.locationMap.push({
                    name: `Environment ${dbTypeName}`,
                    sref: this.$state.current.name
                });
            break;
        case 'app.authorized.project-impact-analysis':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.name = this.sessionService.get(`project_${this.$state.params.projectId}`);
            this.locationMap.push({
                name: this.name,
                sref: 'app.authorized.environments',
                params: { id: this.$state.params.projectId }
            });

            this.locationMap.push({
                    name: 'Environments',
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.projectId }
                });
            this.locationMap.push({
                    name: `${reportType[this.$state.params.jobType ? this.$state.params.jobType : 'default']}   Report`,
                    sref: 'app.authorized.project-impact-analysis',
                    params: {
                        projectId: this.$state.params.projectId,
                        jobId: this.$state.params.jobId,
                        jobType: this.$state.params.jobType,
                        jobEnv: this.$state.params.jobEnv
                    }
                });
            break;
        case 'app.authorized.environment.activities':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                    name: this.name,
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            this.locationMap.push({
                    name: 'Environments',
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            envNameSref = 'app.authorized.environment.activities';
            this.addEnvNameToBreadCrumbs(envNameSref);
            this.locationMap.push({
                    name: 'Environment Activities',
                    sref: 'app.authorized.environment.activities'
                });
            break;
        case 'app.authorized.environment.deployedPackages':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                    name: this.name,
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            this.locationMap.push({
                    name: 'Environments',
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            envNameSref = 'app.authorized.environment.deployedPackages';
            this.addEnvNameToBreadCrumbs('app.authorized.environment.deployedPackages');
            this.locationMap.push({
                    name: 'Environment Deployed Packages',
                    sref: 'app.authorized.environment.deployedPackages'
                });
            break;
        case 'app.authorized.projectWizard.settings':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
                // this.locationMap.push({
                //    name : 'Environments',
                //    sref : 'app.authorized.environments',
                //    params : { id : this.$state.params.id }
                // });
            this.locationMap.push({ name: 'Add Project', sref: 'app.authorized.projectWizard.settings' });
            break;
        case 'app.authorized.projectWizard.envTypes':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({ name: 'Add Project', sref: 'app.authorized.projectWizard.settings' });
            this.locationMap.push({ name: 'Environment Types', sref: 'app.authorized.projectWizard.envTypes' });
            break;
        case 'app.authorized.projectWizard.assignSchemas':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({ name: 'Add Project', sref: 'app.authorized.projectWizard.settings' });
            this.locationMap.push({ name: 'Environment Types', sref: 'app.authorized.projectWizard.envTypes' });
            this.locationMap.push({
                    name: 'Environments Configurations',
                    sref: 'app.authorized.projectWizard.assignSchemas'
                });
            break;
        case 'app.authorized.usersRolesManagement.usersManagement':
        case 'app.authorized.usersRolesManagement.usersManagement.users':
            this.locationMap.push({
                    name: 'Users & Roles',
                    sref: 'app.authorized.usersRolesManagement.usersManagement.users'
                });
            this.locationMap.push({
                    name: 'User Management',
                    sref: 'app.authorized.usersRolesManagement.usersManagement.users'
                });
            this.locationMap.push({
                    name: 'Users',
                    sref: 'app.authorized.usersRolesManagement.usersManagement.users'
                });
            break;
        case 'app.authorized.usersRolesManagement.usersManagement.usersGroups':
            this.locationMap.push({
                    name: 'Users & Roles',
                    sref: 'app.authorized.usersRolesManagement.usersManagement.users'
                });
            this.locationMap.push({ name: 'User Management', sref: this.$state.current.name });
            this.locationMap.push({ name: 'User Groups', sref: this.$state.current.name });
            break;
        case 'app.authorized.usersRolesManagement.rolesManagement':
            this.locationMap.push({
                    name: 'Users & Roles',
                    sref: 'app.authorized.usersRolesManagement.usersManagement.users'
                });
            this.locationMap.push({ name: 'Role Management', sref: this.$state.current.name });
            break;
        case 'app.authorized.usersRolesManagement.projectManagement':
            this.locationMap.push({
                    name: 'Users & Roles',
                    sref: 'app.authorized.usersRolesManagement.usersManagement.users'
                });
            this.locationMap.push({ name: 'Project Management', sref: this.$state.current.name });
            break;
        case 'app.authorized.usersRolesManagement.advancedManagement.domainManager':
            this.locationMap.push({
                    name: 'Users & Roles',
                    sref: 'app.authorized.usersRolesManagement.usersManagement.users'
                });
            this.locationMap.push({ name: 'Advanced', sref: this.$state.current.name });
            this.locationMap.push({ name: 'Domain Manager', sref: this.$state.current.name });
            
            break;
        case 'app.authorized.usersRolesManagement.advancedManagement.projectGroups':
            this.locationMap.push({
                    name: 'Users & Roles',
                    sref: 'app.authorized.usersRolesManagement.usersManagement.users'
                });
            this.locationMap.push({ name: 'Advanced', sref: this.$state.current.name });
            this.locationMap.push({ name: 'Project Groups', sref: this.$state.current.name });
            break;
            case 'app.authorized.usersRolesManagement.advancedManagement.oidcConfiguration':
                this.locationMap.push({
                        name: 'Users & Roles',
                        sref: 'app.authorized.usersRolesManagement.usersManagement.users'
                    });
                this.locationMap.push({ name: 'Advanced', sref: this.$state.current.name });
                this.locationMap.push({ name: 'OIDC Configuration', sref: this.$state.current.name });
            break;
        case 'app.authorized.myProfile':
            this.locationMap.push({ name: 'My Profile', sref: 'app.authorized.myProfile' });
            break;
        case 'app.authorized.about':
            this.locationMap.push({ name: 'About', sref: 'app.authorized.about' });
            break;
        case 'app.authorized.debugPage':
            this.locationMap.push({ name: 'Debug', sref: 'app.authorized.debugPage' });
            break;
        case 'app.authorized.policyEngine.rulesManagement':
            this.locationMap.push({
                    name: 'Policy Manager',
                    sref: 'app.authorized.policyEngine.rulesManagement',
                    params: { index: 0 }
                });
            this.locationMap.push({ name: 'Rules', sref: 'app.authorized.policyEngine.rulesManagement' });
            break;
        case 'app.authorized.policyEngine.policyManagement':
            this.locationMap.push({
                    name: 'Policy Manager',
                    sref: 'app.authorized.policyEngine.rulesManagement',
                    params: { index: 0 }
                });
            this.locationMap.push({ name: 'Policies', sref: 'app.authorized.policyEngine.policyManagement' });
            break;
        case 'app.authorized.policyEngine.policyEnforcement':
            this.locationMap.push({
                    name: 'Policy Manager',
                    sref: 'app.authorized.policyEngine.rulesManagement',
                    params: { index: 0 }
                });
            this.locationMap.push({ name: 'Policy Enforcement', sref: 'app.authorized.policyEngine.policyEnforcement' });
            break;

        case 'app.authorized.settings.tagTypesManager':
            this.locationMap.push({ name: 'Tag Type Manager', sref: 'app.authorized.settings.tagTypesManager' });
            break;
        case 'app.authorized.hooks':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                    name: this.name,
                    sref: 'app.authorized.environments',
                    params: { id: this.$state.params.id }
                });
            this.locationMap.push({ name: 'Hooks', sref: 'app.authorized.hooks' });
            break;
        case 'app.authorized.objectExclusion':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                name: this.name,
                sref: 'app.authorized.environments',
                params: { id: this.$state.params.id }
            });
            this.locationMap.push({ name: 'Object Scope', sref: 'app.authorized.objectExclusion' });
            break;
        case 'app.authorized.staticContent':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                name: this.name,
                sref: 'app.authorized.environments',
                params: { id: this.$state.params.id }
            });
            this.locationMap.push({ name: 'Static Content', sref: 'app.authorized.staticContent' });
            break;
        case 'app.authorized.backups':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                        name: this.name,
                        sref: 'app.authorized.environments',
                        params: { id: this.$state.params.id }
                    });
            this.locationMap.push({ name: 'Backups', sref: 'app.authorized.backups' });
            break;
        case 'app.authorized.releaseVariable':
            this.locationMap.push({ name: 'Projects', sref: 'app.authorized.projects' });
            this.locationMap.push({
                name: this.name,
                sref: 'app.authorized.environments',
                 params: { id: this.$state.params.id }
                    });
            this.locationMap.push({ name: 'Variables', sref: 'app.authorized.releaseVariable' });
            break;

        default:
            this.locationMap.push({ name: 'DBmaestro', sref: 'app.auth.login' });
            break;
        }
        this.store.dispatch({ type: menuActions.SET_BREADCRUMB, payload: this.locationMap });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/breadcrumbs/breadcrumbs.component.ts